module.exports = __webpack_public_path__ + "img/scheda-bw.125b229b.jpg";